// extracted by mini-css-extract-plugin
export default {"SortOrder":"SortOrder-styles__SortOrder__upcCs","SortOrder__Label":"SortOrder-styles__SortOrder__Label__i0D7S"};